module.exports = __webpack_public_path__ + "img/verify-email-en.21a37bf.png";